import moment from 'moment';
import * as React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { APIError } from '../../APIError';
import ErrorJumbotron from '../../widgets/ErrorJumbotron';
import LoadingIndicator from '../../widgets/LoadingIndicator';
import Panel from '../../widgets/Panel';
import { LOCAL_DATE_FORMAT } from '../../constants';

export type SecurityInvestigationsEntry = [string, string];

export type Props = {
  investigations: Array<SecurityInvestigationsEntry>;
  isLoading: boolean;
  error: APIError | null;
};

export default class SecurityInvestigations extends React.Component<Props> {
  render() {
    const { error, investigations, isLoading } = this.props;
    const weekData = investigations.map((row) => ({
      date: moment(row[0]).utc().format(LOCAL_DATE_FORMAT),
      y: Number(row[1]),
    }));
    let indicator = null;
    if (isLoading) {
      indicator = (
        <LoadingIndicator size="lg" centered>
          Loading chart data...
        </LoadingIndicator>
      );
    }
    if (error) {
      indicator = <ErrorJumbotron error={error} className="vertical-center" />;
    }

    return (
      <Panel className="d-flex flex-column">
        <div>
          <h2 className="mb-4">Security Investigations</h2>
        </div>
        {indicator}
        <ResponsiveContainer width="100%" height={430}>
          <BarChart data={weekData}>
            <CartesianGrid vertical={false} />
            <YAxis
              axisLine={false}
              tickLine={false}
              tickMargin={16}
              width={60}
            />
            <XAxis dataKey="date" tickMargin={16} />
            <Bar
              barSize={50}
              dataKey="y"
              stackId="a"
              className="dashboard-chart"
              animationBegin={0}
              animationDuration={250}
              animationEasing="linear"
            />
          </BarChart>
        </ResponsiveContainer>
      </Panel>
    );
  }
}
